import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import type { RolesConfigResponse } from '@/features/auth/types/rolesConfig'
import {
  defaultSessionTimeout,
  renterSessionTimeout,
  sessionTimeoutFromMinutes,
  type SessionTimeoutConfig,
} from './sessionTimeoutConfig'

export async function loadSessionTimeoutConfig(
  roleName: string | undefined,
): Promise<SessionTimeoutConfig> {
  if (roleName === 'ROLE_RENTER') {
    return renterSessionTimeout()
  }

  try {
    const response = await apiClient.get<RolesConfigResponse>(API_ENDPOINTS.ROLES_CONFIG)
    const minutes = response.data?.session_timeout
    if (minutes != null && Number(minutes) > 0) {
      return sessionTimeoutFromMinutes(Number(minutes))
    }
  } catch {
    /* fall through to defaults */
  }

  return defaultSessionTimeout()
}
